import React from 'react';
import PlaceholderPage from '../components/PlaceholderPage';

const AnalyticsPage = () => (
  <PlaceholderPage 
    title="Analytics Dashboard"
    features={[
      'Equipment uptime trends (line chart, 30 days)',
      'Procedure volume by type (bar chart)',
      'Equipment workload distribution (pie chart)',
      'Facility comparison metrics',
      'Vendor performance analytics',
      'Request success rate tracking',
      'Export reports to PDF/CSV',
      'Date range filtering'
    ]}
  />
);

export default AnalyticsPage;
